import React from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { Panel } from '../Panel/Panel'
import { Field } from '../Field/Field'
import { ExtraFieldsContainer } from '../ExtraFieldsContainer/ExtraFieldsContainer'
import { Button } from '../Button/Button'
import { polyglot } from '../../../index'

export default class PanelWithContent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: props.savedData || {}
    }
    this.sendToDatabase = this.sendToDatabase.bind(this)
  }
  updateExtraFieldState (name, value) {
    const state = this.state.data
    state['extraFields'] = this.state.data.extraFields || {}
    const newObj = update(state, {extraFields: {[name]: {$set: value}}})
    this.setState({
      data: newObj
    })
  }

  updateState (name, value) {
    if (name !== '' && value !== null) {
      const updated = update(this.state.data, {
        [name]: {$set: value}
      })
      this.setState({
        data: updated
      }, () => {
        if (this.props.handleChange) {
          this.props.handleChange(updated, this.props.dataKey)
        }
      })
    }
  }
  sendToDatabase (e) {
    e.preventDefault()
    this.props.saveData(this.state.data, this.props.dataKey)
    if (this.props.dataSendWarning) {
      this.props.dataSendWarning()
    }
  }

  render () {
    return (
      <div>
        <Panel heading={polyglot.t(this.props.title)}>
          <form onSubmit={e => this.sendToDatabase(e)}>
            <div>
              <div className='form-horizontal'>
                {this.props.fields.map(element => {
                  let savedData
                  if (this.props.savedData) {
                    if (element.elements.length > 1) {
                      if (this.props.savedData[element.name]) {
                        savedData = this.props.savedData[element.name]
                      } else {
                        const dataToPass = {}
                        element.elements.forEach(innerElement => {
                          dataToPass[innerElement.name] = this.props.savedData[innerElement.name]
                        })
                        savedData = dataToPass
                      }
                    } else {
                      savedData = this.props.savedData[element.name] || undefined
                    }
                  }
                  return <Field
                    expandInputArea={this.props.expandInputFields}
                    multipleInput={element.multipleInput}
                    key={element.name}
                    type={element.type}
                    name={element.name}
                    savedData={savedData}
                    label={element.label}
                    elements={element.elements}
                    required={element.required}
                    getValue={this.updateState.bind(this)} />
                })}
                {this.props.extraFieldEnabled
                  ? <ExtraFieldsContainer
                    expandInputFields={this.props.expandInputFields}
                    buttonText={polyglot.t(`${this.props.dataKey}.extraFieldButton`)}
                    fields={this.props.extraFieldContent}
                    savedFields={this.state.data && this.state.data.extraFields}
                    getFieldValue={this.updateExtraFieldState.bind(this)} />
                  : null
                }
              </div>
              <div style={{marginTop: '10px'}}>
                <Button text={polyglot.t('staticFields.commonFields.save')} type='submit' buttonType='btn-default pull-right' />
              </div>
            </div>
          </form>
        </Panel>
      </div>
    )
  }
}

PanelWithContent.defaultProps = {
  expandInputFields: false
}
PanelWithContent.propTypes = {
  dataKey: PropTypes.string.isRequired,
  saveData: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  extraFieldEnabled: PropTypes.bool,
  expandInputFields: PropTypes.bool,
  extraFieldContent: PropTypes.object,
  savedData: PropTypes.object,
  dataSendWarning: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/common/PanelWithContent/PanelWithContent.js